import { z } from "zod";

export const OrderUpdateFieldValueSchema = z.object({
	orderFieldId: z.number(),
	value: z.union([z.string(), z.boolean(), z.number()]).nullable().optional(),
	key: z.string(),
});

export const getGeneralFormSchema = () => {
	return z.object({
		address: z.string().nullish(),
		notes: z.string().nullish(),
		marketRegionId: z.number().nullish(),
		fields: z.array(OrderUpdateFieldValueSchema).nullish(),
	});
};

export type GeneralFormModel = z.infer<ReturnType<typeof getGeneralFormSchema>>;
